export default __webpack_public_path__ + "static/media/img5.4d1c2f41.png";